import { HTMLAttributes } from 'react';
import {
  alignSelf,
  color,
  display,
  DisplayProps,
  fontSize,
  fontWeight,
  justifySelf,
  lineHeight,
  LineHeightProps,
  maxWidth,
  space,
  SpaceProps,
  textAlign,
} from 'styled-system';
import { ColoringProps, SelfPositioningProps, TypographyProps } from '~frontend-common/lib/styled-components';
import { styled } from '~ui-kit/styled-components';
import { theme } from '~ui-kit/theme';

export interface TypoProps
  extends DisplayProps,
    SpaceProps,
    LineHeightProps,
    SelfPositioningProps,
    TypographyProps,
    HTMLAttributes<HTMLDivElement>,
    ColoringProps {
  color?: string;
}

/** @deprecated use ~ui-kit/components/typography */
export const H1: React.SFC<TypoProps> = styled.div`
  ${display};
  ${fontSize};
  ${space};
  ${color};
  ${lineHeight};
  ${textAlign};
  ${alignSelf};
  ${justifySelf};
  ${fontSize};
  font-family: ${theme.fontFamily.montserrat};
  ${fontWeight};
` as any;

H1.defaultProps = {
  fontSize: ['54px', '64px'],
  fontWeight: 500,
};

/** @deprecated use ~ui-kit/components/typography */
export const H2: React.SFC<TypoProps> = styled.div`
  ${display};
  ${fontSize};
  ${space};
  ${color};
  ${lineHeight};
  ${textAlign};
  ${alignSelf};
  ${justifySelf};
  ${fontWeight}
  font-family: ${theme.fontFamily.montserrat};
` as any;

H2.defaultProps = {
  fontSize: ['36px'],
};

/** @deprecated use ~ui-kit/components/typography */
export const H3: React.SFC<TypoProps> = styled.div`
  ${display};
  ${fontSize};
  ${space};
  ${color};
  ${lineHeight};
  ${textAlign};
  ${alignSelf};
  ${justifySelf};
  ${fontSize};
  ${fontWeight}

  font-family: ${theme.fontFamily.montserrat};
` as any;

H3.defaultProps = {
  fontSize: ['32px'],
  fontWeight: 500,
};

/** @deprecated use ~ui-kit/components/typography */
export const Caption2: React.SFC<TypoProps> = styled.div`
  ${display};
  ${alignSelf};
  ${justifySelf};
  ${space};
  ${color};
  ${lineHeight};
  ${textAlign};
  ${maxWidth};
  ${fontSize};
  ${fontWeight};
  font-family: ${theme.fontFamily.montserrat};
` as any;

Caption2.defaultProps = {
  fontWeight: 'normal',
  fontSize: ['12px'],
};

/** @deprecated use ~ui-kit/components/typography */
export const Caption3: React.SFC<TypoProps> = styled.div`
  ${display};
  ${alignSelf};
  ${justifySelf};
  ${space};
  ${color};
  ${lineHeight};
  ${textAlign};
  ${maxWidth};
  ${fontWeight};
  ${fontSize};
  font-family: ${theme.fontFamily.montserrat};
` as any;

Caption3.defaultProps = {
  fontWeight: 'normal',
  fontSize: ['12px'],
};

/** @deprecated use ~ui-kit/components/typography */
export const Subtitle1: React.SFC<TypoProps> = styled.div`
  ${display};
  ${alignSelf};
  ${justifySelf};
  ${space};
  ${color};
  ${lineHeight};
  ${textAlign};
  ${maxWidth};
  ${fontSize};
  font-family: ${theme.fontFamily.montserrat};
  ${fontWeight};
` as any;

Subtitle1.defaultProps = {
  fontWeight: 'normal',
  fontSize: ['20px'],
};

/** @deprecated use ~ui-kit/components/typography */
export const Subtitle2: React.SFC<TypoProps> = styled.div`
  ${display};
  ${alignSelf};
  ${justifySelf};
  ${space};
  ${color};
  ${lineHeight};
  ${textAlign};
  ${maxWidth};
  ${fontWeight};
  ${fontSize};
  font-family: ${theme.fontFamily.poppins};
` as any;

Subtitle2.defaultProps = {
  fontSize: ['20px'],
};

/** @deprecated use ~ui-kit/components/typography */
export const Subtitle3: React.SFC<TypoProps> = styled.div`
  ${display};
  ${alignSelf};
  ${justifySelf};
  ${space};
  ${color};
  ${lineHeight};
  ${textAlign};
  ${maxWidth};
  ${fontWeight};
  ${fontSize};
  font-family: ${theme.fontFamily.poppins};
` as any;

Subtitle3.defaultProps = {
  fontWeight: 'normal',
  fontSize: ['18px'],
};

/** @deprecated use ~ui-kit/components/typography */
export const Subtitle4: React.SFC<TypoProps> = styled.div`
  ${display};
  ${alignSelf};
  ${justifySelf};
  ${space};
  ${color};
  ${lineHeight};
  ${textAlign};
  ${maxWidth};
  ${fontWeight};
  ${fontSize};
  font-family: ${theme.fontFamily.poppins};
` as any;

Subtitle4.defaultProps = {
  fontWeight: 'normal',
  fontSize: ['16px'],
  lineHeight: '24px',
};

/** @deprecated use ~ui-kit/components/typography */
export const Subtitle5: React.SFC<TypoProps> = styled.div`
  ${display};
  ${alignSelf};
  ${justifySelf};
  ${space};
  ${color};
  ${lineHeight};
  ${textAlign};
  ${maxWidth};
  ${fontWeight};
  ${fontSize};
  font-family: ${theme.fontFamily.montserrat};
` as any;

Subtitle5.defaultProps = {
  fontWeight: 'normal',
  fontSize: ['16px'],
};

/** @deprecated use ~ui-kit/components/typography */
export const Subtitle6: React.SFC<TypoProps> = styled.div`
  ${display};
  ${alignSelf};
  ${justifySelf};
  ${space};
  ${color};
  ${lineHeight};
  ${textAlign};
  ${maxWidth};
  ${fontSize};
  font-family: ${theme.fontFamily.montserrat};
  ${fontWeight};
` as any;

Subtitle6.defaultProps = {
  color: theme.colors.black,
  fontSize: ['14px'],
};

/** @deprecated use ~ui-kit/components/typography */
export const Body1: React.SFC<TypoProps> = styled.div`
  ${display};
  ${alignSelf};
  ${justifySelf};
  ${space};
  ${color};
  ${lineHeight};
  ${textAlign};
  ${maxWidth};
  ${fontWeight};
  ${fontSize};
  font-family: ${theme.fontFamily.poppins};
` as any;

Body1.defaultProps = {
  fontSize: ['12px', '14px'],
};
